import { PermissionMap } from '@store/async/service';
import { State } from '@store/index';
import { Resource } from '@store/types';
import { useSelector } from 'react-redux';

export const usePermissions = (service_id: string | null, resource: Resource) => {
  const services = useSelector((state: State) => state.flow.services);
  const isLoading = useSelector((state: State) => state.flow.flowLoading);

  const service = services?.find((service) => service.service_id === service_id);
  const isAdmin = service?.admin;

  const permissionMap = service?.permissions as PermissionMap;
  const permissions = permissionMap?.[resource];

  const isWorkspaceAdmin = (serviceId: string) => {
    try {
      if (!services || !services?.length) return false;
      const workspace = services.find((service) => service.service_id === serviceId);
      return workspace?.admin;
    } catch (e) {
      return false;
    }
  };

  return { admin: isAdmin, permissions, isWorkspaceAdmin, loading: isLoading };
};
